// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"53":"a00f8ed4","647":"0a90ccdf"}[chunkId] + ".js";
};